<template>
    <div class="home">
            <HomeNav></HomeNav>
            <HomeSearch></HomeSearch>
            <HomeSwipe></HomeSwipe>
            <HomeGrid></HomeGrid>
            <HomeCenterNav></HomeCenterNav>
    </div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import HomeNav from "@/components/HomeNav.vue";
import HomeSearch from "@/components/HomeSearch.vue";
import HomeSwipe from "@/components/HomeSwipe.vue";
import HomeCenterNav from "@/components/HomeCenterNav.vue";
import HomeGrid from "@/components/HomeGrid.vue";


export default {
    name: "home",
    components: {
        HomeNav,
        HomeSearch,
        HomeSwipe,
        HomeCenterNav,
        HomeGrid
    }
};
</script>
